<template>
  <Section id="contact" class="contact">
    <div class="componata-container --is-narrow">
      <div class="grid">
        <div class="col-8_sm-12">
          <SectionHeader textAlign="left">
            <template v-slot:title>Nehmen Sie Kontakt mit uns auf</template>

            <template v-slot:description>
              <p>Bitte füllen Sie das untenstehende Kontaktformular aus und unser Firmenkundenservice wird sich in Kürze
                (spätestens am nächsten Werktag) bei Ihnen melden.</p>
            </template>
          </SectionHeader>

          <div class="contact__wrapper" ref="wrapper">
            <Alert v-if="contactForm.error" type="error">Leider gab es ein Problem beim Versenden Ihrer Nachricht. Bitte
              versuchen
              Sie es erneut oder senden Sie eine E-Mail an <a
                href="mailto:kundenservice@componata.de">kundenservice@componata.de</a></Alert>

            <form v-if="!contactForm.isSubmitted" @submit.prevent="sendContactForm($event)" class="form contact__form"
              data-context="contact-form">
              <div class="grid" v-if="minimized != 'true'">
                <div class="col-2_lg-3_xs-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_stuck'">Anzahl</label>
                    <input v-model="quantity" :id="uid + '_contact_stuck'" type="number" min="1" max="2000"
                      class="form__control" required>
                  </div>
                </div>

                <div class="col-3_lg-3_xs-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_budget'">Budget <Popper trigger="hover"><span class="u-text-muted"><i
                            class="icon icon-question-circle"></i></span> <template v-slot:popover>Bitte geben Sie den
                          Nettobetrag an.</template></Popper></label>
                    <input v-model="contactForm.budget" :id="uid + '_contact_budget'" type="text" class="form__control"
                      placeholder="30 €" autocomplete="off">
                  </div>
                </div>

                <div class="col-7_lg-6_xs-12">
                  <div class="form__group form__check">
                    <label>Optionale</label>
                    <input :id="uid + '_contact_multiple_addresses'" type="checkbox"
                      v-model="multipleShippingAddresses">
                    <label :for="uid + '_contact_multiple_addresses'">Versand an verschiedene Adressen <Popper
                        trigger="hover">
                        <span class="u-text-muted"><i class="icon icon-question-circle"></i></span> <template
                          v-slot:popover>Wir können den Direktversand an bspw. Ihre Mitarbeiter oder Geschäftspartner
                          übernehmen oder wir liefern gebündelt an Ihre Büroadresse - Sie haben die Wahl.</template>
                      </Popper></label>
                  </div>
                </div>
              </div>

              <span class="contact__divider"></span>

              <div class="grid">
                <div class="col-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_company'">Unternehmen</label>
                    <input v-model="contactForm.company" :id="uid + '_contact_company'" type="text"
                      class="form__control" required>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_name'">Ansprechpartner</label>
                    <input v-model="contactForm.name" :id="uid + '_contact_name'" type="text" class="form__control"
                      required>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_email'">E-Mail</label>
                    <input v-model="contactForm.email" :id="uid + '_contact_email'" type="email" class="form__control"
                      required>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form__group">
                    <label :for="uid + '_contact_phone'">Telefonnummer</label>
                    <input v-model="contactForm.phone" :id="uid + '_contact_phone'" type="tel" class="form__control"
                      required>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form__group">
                    <label :for="uid + '_contact_comment'">Nachricht <span
                        class="u-text-muted">(Optional)</span></label>
                    <p class="u-text-muted">Gerne können Sie auch weitere Informationen zu den gewünschten Präsenten und
                      Produkten
                      oder weitere Anforderungen angeben.</p>
                    <textarea v-model="contactForm.message" :id="uid + '_contact_comment'" class="form__control"
                      rows="4" placeholder="Geben Sie hier Ihre Nachricht oder Frage ein…"></textarea>
                  </div>
                </div>
              </div>

              <div class="contact__submission">
                <Button type="submit" appearance="primary" size="large" :data-ga="'quiz_contact'">Senden</Button>
              </div>
            </form>

            <div data-context="contact-success" v-if="contactForm.isSubmitted">
              <p><i class="icon icon-check-circle contact__success-icon"></i></p>
              <h3>Vielen Dank, wir haben Ihre Nachricht erhalten!</h3>
              <p>Wir werden uns in Kürze mit Ihnen in Verbindung setzen.</p>
            </div>
          </div>

          <img :srcset="`
              ${require('@/assets/images/landing-page/phone-operator@2x.png')}?format=${webPFormat('png')}&width=1442&nearlossless=1&compression=4 2x,
              ${require('@/assets/images/landing-page/phone-operator@2x.png')}?format=${webPFormat('png')}&width=721&nearlossless=1&compression=4 1x
            `"
            :src="`${require('@/assets/images/landing-page/phone-operator@2x.png')}?format=${webPFormat('png')}&width=721&nearlossless=1&compression=4`"
            alt="We will call you!" class="contact__phone-operator">
        </div>
      </div>
    </div>
  </Section>
</template>

<script>
/* global grecaptcha */
import axios from 'axios';

import { UiMixin } from '@/mixins/UiMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Section from '@/components/PresentPage/Section';
import SectionHeader from '@/components/PresentPage/SectionHeader';
import Alert from '@/components/Alert';
import Button from '@/components/Common/Button';
import Popper from '@/components/Popper';

export default {
  name: 'Contact',
  mixins: [UiMixin, helperMixin],
  components: {
    Section,
    SectionHeader,
    Alert,
    Button,
    Popper
  },
  props: {
    landingPageName: {
      type: String,
      default: 'Default',
    },
    minimized: {
      default: false
    }
  },
  data() {
    return {
      uid: 0,
      quantity: 20,
      recaptchaToken: null,
      multipleShippingAddresses: false,
      contactForm: {
        isSubmitted: false,
        error: false,
        budget: '',
        company: '',
        name: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  methods: {
    loadRecaptchaScript() {
      if (!window.grecaptcha) {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    },
    async getRecaptchaToken(action) {
      if (!window.grecaptcha) {
        return null;
      }

      try {
        const token = await grecaptcha.execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {
          action: action, // Beispiel: 'submit' oder 'login'
        });
        return token;
      } catch (error) {
        return null;
      }
    },
    async sendContactForm(event) {
      const token = await this.getRecaptchaToken('submit');

      this.contactForm.error = false;
      this.$store.commit('setGlobalLoading', true);
      if (token) {
        axios
          .post(process.env.VUE_APP_BASE_URL + '/verify-recaptcha.php', { token })
          .then((responseRe) => {
            if (responseRe.data.success) {
              const contactDetails = {
                quantity: this.quantity,
                multipleShippingAddresses: this.multipleShippingAddresses,
                budget: this.contactForm.budget,
                company: this.contactForm.company,
                name: this.contactForm.name,
                email: this.contactForm.email,
                phone: this.contactForm.phone,
                message: this.contactForm.message,
                presentName: this.$store.getters.getSelectedItem.data.name,
                presentId: this.$store.getters.getSelectedItem.data.id,
                minimizedForm: this.minimized
              };

              axios
                .post(process.env.VUE_APP_BASE_URL + '/wp-json/quiz/send', contactDetails)
                .then(response => {
                  if (response.data.status) {
                    this.keepWrapperHeight();

                    this.$store.commit('setGlobalLoading', false);

                    this.contactForm.isSubmitted = true;

                    this.gTag();

                    this.scrollTo('contact');
                  } else {
                    this.contactForm.error = true;
                  }
                })
                .catch(() => {
                  this.$store.commit('setGlobalLoading', false);
                  this.contactForm.error = true;
                });
            } else {
              // Validierung fehlgeschlagen
              this.scrollTo('contact');
              this.contactForm.error = true;
              this.contactForm.isSubmitted = true;
              this.$store.commit('setGlobalLoading', false);
            }
          })
          .catch((error) => {
            if (error) {
              this.scrollTo('contact');
              this.contactForm.error = true;
              this.contactForm.isSubmitted = true;
              this.$store.commit('setGlobalLoading', false);
            }
          });
      } else {
        this.scrollTo('contact');
        this.contactForm.error = true;
        this.contactForm.isSubmitted = true;
        this.$store.commit('setGlobalLoading', false);
      }
    },

    keepWrapperHeight() {
      this.$refs.wrapper.style.height = this.$refs.wrapper.scrollHeight + 'px';
    },
    gTag() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'contactFormSuccess',
        campaing: this.landingPageName
      });
    }
  },
  created() {
  },
  mounted() {
    this.loadRecaptchaScript();
  }
};
</script>

<style lang="scss" scoped>
/**
 * Contact
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Contact area with form
 * @since 2021-01-20
**/

$component: 'contact';

.#{$component} {
  position: relative;
  overflow: hidden;
  padding-bottom: 0 !important;
  background: linear-gradient(150deg, #F9F5EF 72%, #FFFFFF 80%);
  z-index: 0;

  // LP Container position
  .componata-container {
    position: relative;
  }

  // Form
  &__wrapper {
    max-width: 86%;
    @include margin-bottom(map-get($spacers, 4) * 4);
  }

  &__form {
    // @include font-size($font-size-sm);

    // Exceptions and custom styling
    label .icon {
      @include font-size($font-size-base * 1.5);
      vertical-align: top;
    }
  }

  &__divider {
    display: block;
    height: 0;
    @include margin-top(map-get($spacers, 1));
    @include margin-bottom(map-get($spacers, 3));
    border-top: 1px solid $gray-ghost;
  }

  &__submission {
    @include margin-top(map-get($spacers, 3));

    ::v-deep .btn {
      width: 100%;
    }
  }

  &__success-icon {
    color: $green;
    @include font-size($font-size-lg * 3);
  }

  // Artwork Phone Operator Positioning
  &__phone-operator {
    max-width: 52rem;
    position: absolute;
    right: -20%;
    bottom: 0;
    z-index: -1;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {}

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {}

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__wrapper {
      max-width: 100%;
    }

    &__phone-operator {
      display: none;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {}
}
</style>
